<template>
  <div class="not-data">
    <p class="mb-0">Không có dữ liệu</p>
  </div>
</template>

<script>
export default {
  name: "NotData"
}
</script>

<style scoped>
.not-data {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #929292;
  background-color: white;
}

</style>